import { api } from '@/lib/api';

/**
 * Upload an image file to Bunny CDN via the admin API.
 * Returns metadata: { id, url, path, content_type, size }
 */
export const uploadImage = async (file, prefix = 'images') => {
    const form = new FormData();
    form.append('file', file);
    const { data } = await api.post('/admin/upload', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: prefix ? { prefix } : undefined,
    });
    return data;
};

/**
 * Upload a PDF file to Bunny CDN via the admin API.
 */
export const uploadPdf = async (file, prefix = 'pdfs') => {
    const form = new FormData();
    form.append('file', file);
    const { data } = await api.post('/admin/upload-pdf', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: prefix ? { prefix } : undefined,
    });
    return data;
};

/**
 * Delete a file from Bunny CDN by CDN URL (path is auto-extracted server-side).
 */
export const deleteRemoteFile = async (url) => {
    if (!url) return null;
    const { data } = await api.delete('/admin/files', { params: { url } });
    return data;
};
